module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-63.09ef946.woff2";